<template>
  <div class="product-tabPaneConrtent">
    <div class="product-tabPaneConrtent-content " v-if="dataList && dataList.length > 0">
      <Card v-for="item in dataList" :key="item.id" :item="item" @viewDetails="viewDetails" />

    </div>
    <div v-if="dataList && dataList.length > 0"
      class="product-tabPaneConrtent-content-mobile animate__animated animate__slideInRight">
      <CardMobile v-for="item in dataList" :key="item.id" :item="item" @viewDetails="viewDetails" />
    </div>
    <div v-if="dataList && dataList.length === 0" class="product-tabPaneConrtent-content-no">
      暂无数据
    </div>
    <div style="margin-bottom: 50px;margin-top: 30px;">
      <a-pagination v-model:current="pagination.current" v-model:page-size="pagination.pageSize" :total="list.length"
        @change="handelChange" :show-total="total => `共 ${total} 条`" :pageSizeOptions="['12', '24', '36', '48', '60']"
        show-size-changer show-quick-jumper :showQuickJumper="true" />
    </div>

  </div>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'
import Card from "./card.vue"
import CardMobile from "./cardMobile.vue"

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  }
})
const emit = defineEmits(['viewDetails'])

const pagination = reactive({
  current: 1,
  pageSize: 12
})


const list = computed(() => {
  let _list = []
  if (props.data?.associationFields589c8f25) {
    _list = props.data.associationFields589c8f25
  }
  _list.sort(function (a, b) {
    return b.number52288da3 - a.number52288da3;
  });
  return _list
})

const dataList = computed(() => {
  return list.value.slice((pagination.current - 1) * pagination.pageSize, pagination.current * pagination.pageSize)
})

const viewDetails = (data) => {
  emit('viewDetails', data, list.value)
}

function step () {
  window.scrollTo({
    top: (0)
  })
}
function handleScrollTop () {
  window.requestAnimationFrame(step)
}

const handelChange = () => {
  handleScrollTop()
}

</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
  .product-tabPaneConrtent {
    padding: 0 2% 0 2% !important;
  }

  .product-tabPaneConrtent-content {
    display: none !important;
  }

  .product-tabPaneConrtent-content-mobile {
    display: block !important;
  }
}



@media screen and (min-width: 800px) {
  .product-tabPaneConrtent {
    padding: 0 19% 0 18% !important;
  }

  .product-tabPaneConrtent-content {
    display: block !important;
  }

  .product-tabPaneConrtent-content-mobile {
    display: none !important;
  }
}

.product-tabPaneConrtent {
  width: 100%;
  padding: 0 19% 0 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.product-tabPaneConrtent-content {
  width: 100%;
  padding-right: 10px;
  overflow: auto;
  min-height: 323px;
}

.product-tabPaneConrtent-content-mobile {
  width: 100%;
}

.product-tabPaneConrtent-content-no {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-family: 'PuHuiTiRegular';
  min-height: 323px;
}
</style>